class Env {
  constructor() {
    // Load environment variables from process.env at build time
    this.env = {
      REACT_APP_BACKEND_BASE_URL_V2: process.env.REACT_APP_BACKEND_BASE_URL_V2,
      REACT_APP_BACKEND_BASE_URL_V3: process.env.REACT_APP_BACKEND_BASE_URL_V3,
      REACT_APP_BACKEND_TK_API_VERSION:
        process.env.REACT_APP_BACKEND_TK_API_VERSION,
      REACT_APP_HOMEPAGE: process.env.REACT_APP_HOMEPAGE,
      REACT_GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY,
      REACT_GOOGLE_MAPS_ID: process.env.REACT_APP_GOOGLE_MAPS_ID,
      REACT_APP_API_KEY: process.env.REACT_APP_API_KEY,
      REACT_APP_IAM_BASE_URL: process.env.REACT_APP_IAM_BASE_URL,
      REACT_APP_IAM_REDIRECT_URI: process.env.REACT_APP_IAM_REDIRECT_URI,
      REACT_APP_IAM_CLIENT_ID: process.env.REACT_APP_IAM_CLIENT_ID,
      REACT_APP_IAM_SCOPE: process.env.REACT_APP_IAM_SCOPE,
      REACT_APP_IAM_CODE_CHALLENGE: process.env.REACT_APP_IAM_CODE_CHALLENGE,
      REACT_APP_IAM_CODE_CHALLENGE_METHOD:
        process.env.REACT_APP_IAM_CODE_CHALLENGE_METHOD,
      REACT_APP_IAM_RESPONSE_MODE: process.env.REACT_APP_IAM_RESPONSE_MODE,
      REACT_APP_IAM_RESPONSE_TYPE: process.env.REACT_APP_IAM_RESPONSE_TYPE,
      REACT_APP_IAM_GRANT_TYPE: process.env.REACT_APP_IAM_GRANT_TYPE,
      REACT_APP_IAM_REFRESH_GRANT_TYPE:
        process.env.REACT_APP_IAM_REFRESH_GRANT_TYPE,
      REACT_APP_IAM_CODE_VERIFIER: process.env.REACT_APP_IAM_CODE_VERIFIER,
      ENV: process.env.REACT_APP_ENV,
    };
  }

  /**
   * response parser
   *
   * @return string
   */
  responseParser() {
    return response => {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json();
      }
      if (
        contentType
        && (contentType.indexOf('application/pdf') !== -1
          || contentType.indexOf('application/csv') !== -1
          || contentType.indexOf('text/csv') !== -1
          || contentType.indexOf('application/ms-excel') !== -1)
      ) {
        return response.blob();
      }

      return response.text();
    };
  }

  /**
   * To set the env values
   *
   * @return json
   */
  setEnv() {
    return this.env;
  }

  /**
   * Get the value based on key
   *
   * @return string
   */
  getEnv(key) {
    return this.env[key] || '';
  }

  /**
   * Get all environment variables
   *
   * @return object
   */
  getAllEnv() {
    return this.env;
  }
}

export default new Env();
